import { render, staticRenderFns } from "./btnDialog.vue?vue&type=template&id=4be9c574&scoped=true"
import script from "./btnDialog.vue?vue&type=script&lang=js"
export * from "./btnDialog.vue?vue&type=script&lang=js"
import style0 from "./btnDialog.vue?vue&type=style&index=0&id=4be9c574&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be9c574",
  null
  
)

export default component.exports